import { Currency, ProducerDashboard } from "../interfaces/ProducerDashboard";

/** STATUS CONFIGURATION **/
export const STATUS_MAPPING: Record<string, { label: string, color: "success" | "warning" | "error" | "default" | "info" }> = {
    'CREATED': { label: 'Created', color: 'default' },
    'VERIFICATION': { label: 'Verification (KYC)', color: 'warning' },
    'VALIDATED': { label: 'Validated', color: 'success' },
    'BLOCKED': { label: 'Blocked', color: 'error' },
    'ARCHIVED': { label: 'Archived', color: 'info' },
};

/** CURRENCY SYMBOLS MAPPING **/
export const CURRENCY_SYMBOLS: Record<string, string> = {
    'EUR': '€',
    'GBP': '£',
    'PLN': 'zł',
    'CHF': 'CHF',
    'CZK': 'Kč',
    'HUF': 'Ft',
    'RON': 'lei'
};


export const formatMoney = (amount: number, currency: Currency) => {
    const symbol = CURRENCY_SYMBOLS[currency] || currency;
    const formattedAmount = new Intl.NumberFormat('fr-FR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(amount);

    // \u00A0 insecable space
    return currency === 'GBP' ? `${symbol}${formattedAmount}` : `${formattedAmount}\u00A0${symbol}`;
};

export const isStatusDesync = (s1: string, s2: string) => {
    return s1 !== s2
}

export const formatDate = (date: number | string): string => {
    var newDate;
    if (typeof date === 'number') {
        newDate = new Date(date * 1000)
    } else {
        const parsedDate = Date.parse(date);
        newDate = new Date(parsedDate)
    }

    return newDate.toLocaleString();
}

export const lmwApiError = (dashboard: ProducerDashboard): string => {
    const errors = [];
    if (dashboard.balance == null) { errors.push("Wallet amount") }
    if (dashboard.institution_status == null) { errors.push("Status") }
    if (dashboard.wallet_transactions == null) { errors.push("Transactions") }
    if (dashboard.documents == null) { errors.push("Documents") }

    return errors.join(', ');
}

export const isApiError = (data: ProducerDashboard): boolean => {
    return data.balance == null
        || data.institution_status == null
        || data.documents == null
        || data.wallet_transactions == null;
}